import { useParams } from "react-router-dom";
import PosterGrid from "../../components/media/PosterGrid";
import EmptyState from "../../components/ui/EmptyState";
import QueryBoundary from "../../components/ui/QueryBoundary";
import useApiQuery from "../../hooks/useApiQuery";
import useScrollTop from "../../hooks/useScrollTop";
import endpoints from "../../api/endpoints";
import { detailPath, mergeCatalog } from "../../lib/catalog";

const CategoryPage = () => {
  const { id: slug } = useParams();
  const query = useApiQuery(endpoints.category(slug));
  useScrollTop([slug]);

  return (
    <QueryBoundary {...query}>
      {(category) => {
        const items = mergeCatalog(category);

        return (
          <>
            <div className="h-[400px] w-full text-white md:h-screen">
              <div className="pointer-events-none absolute h-[400px] w-full select-none bg-gradient-to-l from-black md:h-screen" />
              <div className="absolute top-[10%] w-full p-4 md:top-[30%] md:p-8">
                <h1 className="mx-auto text-3xl font-bold md:text-5xl">
                  {category.title}
                </h1>
                <p
                  className="mt-6 w-full text-justify text-sm font-bold text-gray-200 md:max-w-[70%] md:text-xl lg:max-w-[50%] xl:max-w-[35%]"
                  style={{ whiteSpace: "pre-wrap" }}
                >
                  {category.discription}
                </p>
              </div>
              <img
                src={category.image}
                alt={category.title}
                className="h-full w-full object-cover"
              />
            </div>

            <div className="mb-20 px-4 py-8 md:px-12">
              {items.length > 0 ? (
                <PosterGrid items={items} linkTo={detailPath} />
              ) : (
                <EmptyState message="محتوایی در این دسته‌بندی نیست." />
              )}
            </div>
          </>
        );
      }}
    </QueryBoundary>
  );
};

export default CategoryPage;
